// client/src/locales/nl`

const nl = {
  translation: {
    form: {
      form_submit: "Formulier indienen",
      make_a_choice: "Maak een keuze",
      form_checked: "Ja",
      form_not_checked: "Nee"
    },
    general: {
      readMore: 'Lees meer',
      loading: 'Laden',
      close: 'Sluit'
    },
    blocks: {
      imageContainer: {
        error: 'Fout bij laden afbeelding'
      },
      mapBlock: {
        visitWebsite: 'Bekijk website',
        map: 'Kaart',
        list: 'Lijst'
      }
    },
    searchbar: {
      label: 'Waar bent u naar op zoek?',
      placeholder: 'Zoeken op trefwoord'
    },
    header: {
      language: "Taal"
    },
    footer: {
      links: {
        privacy: "Privacy",
        terms_conditions: "Algemene voorwaarden"
      },
      follow_us: "Volg ons"
    },
    404: {
      title: "Sorry, we kunnen deze pagina niet vinden",
      description:
        "<p>De pagina bestaat niet (meer) of is misschien verhuisd. Gebruik de zoekmachine om de informatie te vinden die je zoekt.</p>",
      link: "/",
      homepage: "Naar homepage"
    },
    searchResults: {
      title: 'Waar ben je naar op zoek?',
      formLabel: 'Jou zoekopdracht',
      noSearchTerm: 'U hebt geen zoekterm opgegeven',
      types: {
        page: 'Pagina',
        news: 'Nieuws',
        stories: 'Verhaal',
        vacancy: 'Vacature'
      },
      noResults: 'Geen resultaten gevonden. Probeer het opnieuw met deze tips:',
      noResultsTips: {
        spelling: 'Controleer uw spelling',
        describe: 'Beschrijf uw zoekopdracht anders',
        shorter: 'Maak uw zoekopdracht kleiner'
      }
    },
    pagination: {
      previous: 'Vorige',
      next: 'Volgende'
    },
    show_button: {
      more: 'Toon meer',
      less: 'Toon minder'
    }
  }
};

export default nl;
